import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 px-4" data-id="element-66">
      <div className="max-w-xl mx-auto" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border-2 border-gray-200 p-6 sm:p-8 rounded-2xl text-center shadow-sm" data-id="element-68">
          <ShieldCheckIcon className="w-12 h-12 text-swiss-charcoal mx-auto mb-4" data-id="element-69" />
          <h3 className="text-xl sm:text-2xl font-black text-swiss-charcoal uppercase mb-4" data-id="element-70">
            🛡️ 7-TAGE-ZUFRIEDENHEITSGARANTIE
          </h3>
          <p className="text-gray-700 text-sm sm:text-base font-medium leading-relaxed" data-id="element-71">
            Wir sind von der Qualität unseres Systems überzeugt. Wenn Sie
            innerhalb von 7 Tagen nach dem Kauf nicht vollständig zufrieden
            sind, erstatten wir Ihnen den vollen Betrag. Ohne Fragen. Ohne
            Formulare. Ohne Risiko.
          </p>
        </motion.div>
      </div>
    </section>;
}